export interface ClientAccessLog {
  id?: string;
  clientId: string;
  nombre: string;
  telefono: string;
  ultimo_acceso?: string | Date;
}

/**
 * Sends client access logging payload to the backend server endpoint.
 * This avoids client-side Firestore security rules permission issues.
 */
export async function recordClientAccess(data: {
  clientId: string;
  nombre: string;
  telefono: string;
}): Promise<void> {
  if (!data.clientId) return;

  try {
    const response = await fetch("/api/client-register/log-access", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      console.warn(`[ClientAccess] Log response status: ${response.status}`);
    }
  } catch (error) {
    // Non-blocking error so client navigation is never interrupted
    console.warn("No se pudo enviar log de acceso al servidor:", error);
  }
}

